import React from 'react';
import { Card } from '../../UserLookup/components/CardProps';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

interface Props {
  info: Card;
}

const Infoinfo: React.FC<Props> = ({ info }) => {
  const dateCreated = format(toZonedTime(info.createdUTC, '-10:00'), 'MM/dd/yyyy, hh:mmaaa');
  const dateLastUpdate = format(toZonedTime(info.lastUpdatedUTC, '-10:00'), 'MM/dd/yyyy, hh:mmaaa');
  const dateSessionExpired = format(toZonedTime(info.sessionExpirationUTC, '-10:00'), 'MM/dd/yyyy, hh:mmaaa');

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body1">
          <b>Email: </b>
          {info.email}
        </Typography>
        <Typography variant="body1">
          <b>Config Name: </b>
          {info.configName}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body1">
          <b>Application UID:</b> {info.appUid}
        </Typography>
        <Typography variant="body1">
          <b>Created: </b>
          {dateCreated}
        </Typography>
        <Typography variant="body1">
          <b>Last Updated: </b>
          {dateLastUpdate}
        </Typography>
        <Typography variant="body1">
          <b>OnDemand Config Id: </b>
          {info.onDemandConfigId}
        </Typography>
        <Typography variant="body1">
          <b>Current Subflow Name: </b>
          {info.currentSubflowName}
        </Typography>
        <Typography variant="body1">
          <b>Current Subflow Id: </b>
          {info.currentSubflowId}
        </Typography>
        <Typography variant="body1">
          <b>Current Phase Name: </b>
          {info.currentPhaseName}
        </Typography>
        <Typography variant="body1">
          <b>Current Phase Id: </b>
          {info.currentPhaseId}
        </Typography>
        <Typography variant="body1">
          <b>Current Status: </b>
          {info.latestStatus}
        </Typography>
        <Typography variant="body1">
          <b>Current Status Detail: </b>
          {info.latestStatusDetails}
        </Typography>
        <Typography variant="body1">
          <b>Application Expired Date: </b>
          {dateSessionExpired}
        </Typography>
        <Typography variant="body1">
          <b>AA Id: </b>
          {info.aaid} {info.partnerName || ''}
        </Typography>
        <Typography variant="body1">
          <b>Affiliate Id: </b>
          {info.affiliateId}
        </Typography>
        <Typography variant="body1">
          <b>{info.isEmailVerified ? 'Email Verified' : 'Email Not Verified'}</b>
        </Typography>
        <Typography variant="body1">
          <b>Email Verdict: </b>
          {info.emailVerdict}
        </Typography>
        <Typography variant="body1">
          <b>{info.isOptedOut ? 'Opted Out' : 'Opted In'}</b>
        </Typography>
        <Typography variant="body1">
          <b>{info.isDisqualified ? 'Disqualified' : 'Not Disqualified'}</b>
        </Typography>
        <Typography variant="body1">
          <b>{info.isCompleted ? 'Completed' : 'Not Completed'}</b>
        </Typography>
        <Typography variant="body1">
          <b>{info.isLeadConverted ? 'Lead is Converted' : 'Lead Not Converted'}</b>
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default Infoinfo;
